// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resourceNew[data-v-6d52b8ba]{background-color:#fff;padding:0 10px 10px 10px}.resourceNew .top-tabs[data-v-6d52b8ba] .el-tabs__nav-scroll{margin-left:20px}[data-v-6d52b8ba] .resourceList .resource-content_pagination{position:fixed;bottom:10%;right:12%};", ""]);
// Exports
module.exports = exports;
